export default {
    'visit-details': 'تفاصيل الزيارة',
    'distributed-samples': 'المواد الموزعة',
    'edit-activity': 'تعديل نشاط',
    'add-new-activity': 'إضافة نشاط جديد',
    'select-activity': 'تحديد نشاط',
    'activity': 'نشاط',
    'visit': 'زيارة',
    'double-visit': 'زيارة مزدوجة',
    'delete-the-activity': 'حذف النشاط',
}